export default "__VITE_ASSET__C6AP6H04__"